import React from 'react';
import { ShoppingCart, Banknote, Handshake } from 'lucide-react';
export function Services() {
  const services = [{
    icon: <ShoppingCart size={32} data-id="element-306" />,
    title: 'Achat de palettes',
    description: "Nous vous accompagnons dans l'achat de palettes adaptées à vos besoins, avec une sélection parmi +500 fournisseurs."
  }, {
    icon: <Banknote size={32} data-id="element-307" />,
    title: 'Vente de palettes',
    description: "Nous rachetons vos palettes en fin de cycle ou en surplus, vous permettant de libérer de l'espace et de générer des revenus."
  }, {
    icon: <Handshake size={32} data-id="element-308" />,
    title: 'Courtage expert',
    description: "Notre expertise de courtage vous garantit les meilleures conditions d'achat et de vente sur le marché européen."
  }];
  return <section id="services" className="py-24 bg-secondary-dark text-white relative overflow-hidden" data-id="element-309">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-310">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-primary blur-3xl" data-id="element-311"></div>
        <div className="absolute top-1/2 right-0 w-64 h-64 rounded-full bg-accent blur-3xl" data-id="element-312"></div>
      </div>

      <div className="w-full max-w-[1200px] mx-auto px-6 relative z-10" data-id="element-313">
        <div className="text-center mb-16" data-id="element-314">
          <span className="text-primary font-semibold tracking-wider uppercase text-sm" data-id="element-315">
            Nos services
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mt-3 mb-6" data-id="element-316">
            Une offre complète pour les pros
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-317">
            Que vous souhaitiez acheter, vendre ou optimiser votre parc, nous
            avons la solution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-318">
          {services.map((service, index) => <div key={index} className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-2xl hover:bg-white/10 hover:-translate-y-2 transition-all duration-300 group" data-id="element-319">
              <div className="w-16 h-16 bg-primary/20 rounded-2xl flex items-center justify-center text-primary mb-6 group-hover:bg-primary group-hover:text-white transition-all duration-300 shadow-lg shadow-primary/10" data-id="element-320">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold mb-4 group-hover:text-primary transition-colors" data-id="element-321">
                {service.title}
              </h3>
              <p className="text-gray-400 leading-relaxed group-hover:text-gray-300 transition-colors" data-id="element-322">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}